// assets
import { FileTextOutlined } from '@ant-design/icons';

// icons
const icons = {
  FileTextOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'documents',
  title: 'Documents',
  type: 'group',
  children: [
    {
      id: 'signed-documents',
      title: 'Documents',
      type: 'item',
      url: '/documents',
      icon: icons.FileTextOutlined
    },
    
  ]
};

export default support;
